import logoutIcon from '@/assets/icons/logout.svg';
import { iconMaskStyle } from '@/shared/lib/icon-mask';

import { GUARDIAN_ACCOUNT_MENU_PANEL_CLASS } from './constants';
import { UserAvatar } from '@/shared/components/UserAvatar';

export interface DefaultAccountMenuProps {
  ariaLabel: string;
  displayName: string;
  userEmail: string;
  avatarUrl?: string;
  logoutLabel: string;
  onLogout: () => void;
}

/** Staff account menu — identity + sign out (same shell as guardian portal menu). */
export function DefaultAccountMenu({
  ariaLabel,
  displayName,
  userEmail,
  avatarUrl,
  logoutLabel,
  onLogout,
}: DefaultAccountMenuProps) {
  return (
    <div role="menu" aria-label={ariaLabel} className={GUARDIAN_ACCOUNT_MENU_PANEL_CLASS}>
      <div className="flex items-center gap-2.5 px-3 py-1.5">
        <UserAvatar
          name={displayName}
          avatarUrl={avatarUrl}
          sizeClassName="size-8"
          textClassName="text-[10px]"
          priority
        />
        <div className="min-w-0 flex-1">
          <p className="truncate text-[13px] font-semibold text-ink-strong">{displayName}</p>
          {userEmail ? (
            <p className="mt-0.5 truncate text-[11px] text-ink-muted/80" title={userEmail}>
              {userEmail}
            </p>
          ) : null}
        </div>
      </div>
      <div className="px-1.5 pb-0.5 pt-0.5">
        <button
          type="button"
          role="menuitem"
          onClick={onLogout}
          className="flex w-full items-center gap-2 rounded-lg px-1.5 py-2 text-left text-[13px] font-medium text-ink-strong transition-colors hover:bg-brand-50"
        >
          <span aria-hidden className="block size-3.5 shrink-0" style={iconMaskStyle(logoutIcon)} />
          <span>{logoutLabel}</span>
        </button>
      </div>
    </div>
  );
}
